export class OrderUpdateModel {
  guid: string;
  order: number;
}
